<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp @onSearch="attachData" @onReset="onResetSearchParams">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.active"
                  placeholder="Vui lòng chọn"
                  @change="attachData"
                >
                  <el-option label="Tất cả" value=""> </el-option>
                  <el-option label="Đang hoạt động" :value="true"> </el-option>
                  <el-option label="Không hoạt động" :value="false">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length === 0"
        @click="deleteProductUnit"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="editProductUnit"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.productProductUnitUpdate')
          : $t('dialog.productProductUnitAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Đơn vị tính">
                  <div class="das-form-input">
                    <div class="label required">Đơn vị tính:</div>
                    <div class="child-w-80">
                      <input
                        v-model="unitItem.unit"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Việt"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Việt:</div>
                    <div class="child-w-80">
                      <input v-model="unitItem.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row align-end">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">Tên tiếng Anh:</div>
                    <div class="child-w-80">
                      <input v-model="unitItem.eng_name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="unitItem.active"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3">Hoạt động</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateProductUnit"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addProductUnit">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import {
  getListProductUnitApi,
  addProductUnitApi,
  updateProductUnitApi,
  deleteProductUnitApi
} from '@/api/configuration/accounting/product/unit.js'
import { getServiceTypeListApi } from '@/api/common/code'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      selectedRows: [],
      serviceTypeOptions: [],
      loading: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Đơn vị tính',
          field: 'unit',
          tooltipField: 'unit'
        },
        {
          headerName: 'Tên tiếng Việt',
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: 'Tên tiếng Anh',
          field: 'eng_name',
          tooltipField: 'eng_name'
        },
        {
          headerName: 'Hoạt động',
          maxWidth: 100,
          field: 'active',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        active: ''
      },
      unitItem: {
        unit: '',
        name: '',
        eng_name: '',
        active: true
        // attribute_category_id: 0,
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    const res = await getServiceTypeListApi()
    this.serviceTypeOptions = res.data
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    onResetSearchParams() {
      this.searchParams.showNotActive = false
      this.attachData()
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.unitItem = {
        unit: '',
        name: '',
        eng_name: '',
        active: true
      }
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addProductUnit() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addProductUnitApi(this.unitItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editProductUnit() {
      const row = this.selectedRows[0]
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.unitItem, row)
    },
    async deleteProductUnit() {
      const ids = this.selectedRows.map(item => item.id) || []
      this.$vxConfirm(this.$t('alert.deleteProductUnitConfirm'), () => {
        deleteProductUnitApi({
          id_list: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async updateProductUnit() {
      const gridApi = this.$refs.agGrid.gridApi
      const selectedRows = gridApi.getSelectedRows()
      this.unitItem.id = selectedRows[0].id
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateProductUnitApi(this.unitItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListProductUnitApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
